<style scoped>
.drop-element {
  color: #cccccc;
  text-align: center;
  width: 100%;
}
.empty-emoji {
  font-size: 80px;
  display: block;
}

.drop.over {
  border: 1px dashed #cccccc; 
}
.item-menu {
  position: absolute;
  left: 20px;
  top: 3px;
  z-index: 99999;
}
.item-menu .btn {
  width: 20px;
  height: 20px;
}
#editable-grid-content .vue-grid-item {
  outline: 1px dashed rgba(170, 170, 170, 0.7);
  outline-offset: 0px;
}

#editable-grid-content .vue-grid-item:hover {
  outline: 1px solid #3b97e3 !important;
}
</style>
<template>
  <v-flex xs12 id="editable-grid-content" @mouseleave="saveLayout()">
        <drop @drop="firstDragEnd(null, ...arguments, $event)" v-if="layout && !layout.length">
          <div
            class="drop-element"
            style="padding: 50px 20px; margin-auto"
          >
            <span data-v-1ae6dca1 class="empty-emoji">╭( ✖_✖ )╮</span>
            Drag one element here to get started
          </div>
        </drop>
        <grid-layout
          ref="gridlayout"
          v-if="layout && layout.length"
          :layout.sync="layout"
          :col-num="12"
          :row-height="5"
          :is-draggable="true"
          :is-resizable="true"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[10, 10]"
          :use-css-transforms="true"
        >
          <grid-item
            v-for="(item, index) in layout"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :key="item.i"
          >
          <!-- @drop="handleDrop(item, ...arguments)" -->
          <!-- drag($event) -->
            <drop
              class="drop"
              style="width: 100%; height: 100%;"
              :class="{ 'over': over === index }"
              @dragover="over = index; "
              @dragleave="over = null;"
              @dragend="over = null;"
              @drop="dragend(item, ...arguments, $event)"
            >
              <div class="item-menu" v-if="activeGrid && activeGrid.i == item.i">
                <v-btn fab dark small color="red" class="btn" v-on:click="remove()">
                  <v-icon dark>delete_forever</v-icon>
                </v-btn>
              </div>
              <div @click="gridClicked(item); activeGrid = item;" style="height: 100%">
                <form-element :element="item.element" :index="index" :key="item.element.id" v-if="item.element && item.element.id"></form-element>
              </div>
            </drop>
          </grid-item>
        </grid-layout>
  </v-flex>
</template>
<script>
import { Drop } from "vue-drag-drop";
import VueGridLayout from "vue-grid-layout";
import Element from "./element.vue";

let mouseXY = {"x": null, "y": null};
let DragPos = {"x": null, "y": null, "w": 1, "h": 1, "i": null};

export default {
  props: ["chart"],
  data: function () {
    return {
      over: false,
      activeElement: null,
      activeGrid: null,
      default: {
        x: 0,
        y: 0,
        w: 12,
        h: 2,
        i: "0",
        element: { code: "first" },
      },
      layout: [],
    };
  },
  components: {
    drop: Drop,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    "form-element": Element,
  },
  methods: {
    saveLayout() {

      this.chart.save(this.layout);
    },
    gridClicked: function (item) {
      // alert("Clicked");
      this.chart.setActiveGrid(item);
      this.chart.save(this.layout);
    },
    remove() {
      if (this.activeGrid) {
       // alert("layout");
        this.layout = this.layout.filter(
          (item) => item.i != this.activeGrid.i
        );
        // this.chart.layout = this.layout;
        this.chart.save(this.layout);
      }
    },
    handleFirstDrop(transferData) {
      const newItem = { ...this.default };
      newItem.element = transferData.data;
      this.layout.push(newItem);
    },
    handleDrop(item, transferData) {
      // const element = transferData.data;
      // if (typeof element.create != "undefined") {
      //   let grid = element.create();
      //   grid.w = 8
      //   grid.h = 6;
      //   grid.height = 6;
      //   console.log("new grid", grid);
      //   const newItem = { ...this.default };
      //   if (item) {
      //     grid.x = item.x + 1;
      //     const index = this.layout.indexOf(item);
      //     this.layout.splice(index + 1, 0, grid);
      //     this.chart.setActiveElement(grid);
      //   } else {
      //     console.log("adding 1", grid);
      //     this.layout.push(grid);
      //     console.log("added 3", this.layout);
      //     this.chart.setActiveElement(grid);
      //   }
      // }

      // const item = index ? this.chart.layout[index] : null;
      
      // console.log("this.chart", this.chart);


      

      this.chart.layout = this.layout;
      const index = this.layout.indexOf(item);
      console.log("index", index);
      console.log("item", item);
      this.chart.addElement(item, transferData.data, index);
      this.chart.save(this.layout);
    
  
    },
    appendElement() {},
    drag: function (e) {

            let parentRect = document.getElementById('editable-grid-content').getBoundingClientRect();
            let mouseInGrid = false;
            if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
                mouseInGrid = true;
            }
            if (mouseInGrid === true && (this.layout.findIndex(item => item.i === 'drop')) === -1) {
                this.layout.push({
                    x: (this.layout.length * 2) % (this.colNum || 12),
                    y: this.layout.length + (this.colNum || 12), // puts it at the bottom
                    w: 12,
                    h: 6,
                    i: 'drop',
                });
            }
            let index = this.layout.findIndex(item => item.i === 'drop');
  
            if (index !== -1) {
                try {
                    this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = "none";
                } catch {
                }
                let el = this.$refs.gridlayout.$children[index];
                el.dragging = {"top": mouseXY.y - parentRect.top, "left": mouseXY.x - parentRect.left};
                let new_pos = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left);
                if (mouseInGrid === true) {
                    this.$refs.gridlayout.dragEvent('dragstart', 'drop', new_pos.x, new_pos.y, 1, 1);
                    DragPos.i = String(index);
                    DragPos.x = this.layout[index].x;
                    DragPos.y = this.layout[index].y;
                }
                if (mouseInGrid === false) {
                    this.$refs.gridlayout.dragEvent('dragend', 'drop', new_pos.x, new_pos.y, 1, 1);
                    this.layout = this.layout.filter(obj => obj.i !== 'drop');
                }
            }
        },
        firstDragEnd: function (item, transferData, e) {
          const newItem = {
                    x: 0,
                    y: 0,
                    w: 12,
                    h: 6,
                    i: "0",
                };

                console.log("DragPos", DragPos);

                let newGrid = this.chart.createGridElement(newItem, transferData.data)
                
                this.layout.push(newGrid);
                this.chart.setActiveGrid(newGrid);
                this.chart.save(this.layout);
        },
        dragend: function (item, transferData, e) {
          console.log("item", item);
          console.log("transferData", transferData);
          this.drag(e);
         
            let parentRect = document.getElementById('editable-grid-content').getBoundingClientRect();
            let mouseInGrid = false;
            if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
                mouseInGrid = true;
            }
            if (mouseInGrid === true) {
                if(DragPos) {
                  // alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
                  this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 1, 1);
                }
                this.layout = this.layout.filter(obj => obj.i !== 'drop');
                 
                // UNCOMMENT below if you want to add a grid-item

                const newItem = {
                    x: DragPos ? DragPos.x : 0,
                    y: DragPos ? DragPos.y : 0,
                    w: 12,
                    h: 6,
                    i: DragPos ? DragPos.i : "0",
                };

                // console.log("DragPos", DragPos);

                let newGrid = this.chart.createGridElement(newItem, transferData.data)
                
                this.layout.push(newGrid);
                this.chart.setActiveGrid(newGrid);
                this.chart.save(this.layout);

                if(DragPos) {
                this.$refs.gridlayout.dragEvent('dragend', DragPos.i, DragPos.x,DragPos.y,1,1);
                try {
                    this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display="block";
                } catch {
                }
                }
                
            }
        }
  },
  computed: {},
  mounted: function () {
    const that = this;
    // console.log("this.chart.layout", this.chart.layout);

    document.addEventListener("dragover", function (e) {
            mouseXY.x = e.clientX;
            mouseXY.y = e.clientY;
        }, false);

    this.chart.layout = this.layout;
    this.chart.setLayout = function (layout) {
      that.layout = layout;
      console.log("updating layout", this.layout);
    };

    this.chart.appendLayout = function (item, newItem) {
      // this.layout = layout;
      console.log("updating layout", this.layout);
    };

    this.chart.updateLayout = function() {
      that.chart.save(that.layout);
    }

    this.chart.loadFromSchema();

    //     var arr = [];
    // arr[0] = "Jani";
    // arr[1] = "Hege";
    // arr[2] = "Stale";
    // arr[3] = "Kai Jim";
    // arr[4] = "Borge";

    // console.log(arr.join());
    // arr.splice(2, 0, "Lene");
    // console.log(arr.join());
  },

  beforeDestroy() {},
};
</script>
